<template>
  <div v-html="apply">{{apply}}</div>
</template>
<script>
let Base64 = require("js-base64").Base64;
export default {
  name: "applyText",
  data() {
    return {
      apply: ""
    };
  },
  mounted() {
    // let ht = this.$route.query.htmls;
    // console.log(ht);
    // let form = this.$route.query.htmls;
    // console.log(form);
    let form = `<form id='alipaysubmit' name='alipaysubmit' action='https://openapi.alipay.com/gateway.do?charset=GBK' method='POST'><input  name='app_id' value='2019062065616578'/><input  name='biz_content' value='{"out_trade_no":"40","product_code":"FAST_INSTANT_TRADE_PAY","subject":"内容分发系统充值订单","total_amount":"100"}'/><input  name='charset' value='GBK'/><input  name='format' value='json'/><input  name='method' value='alipay.trade.page.pay'/><input  name='sign_type' value='RSA2'/><input  name='timestamp' value='2019-06-22 15:01:23'/><input  name='version' value='1.0'/><input  name='sign' value='Eg+Xqrne2Z6C7nAlXf10/V+J7i7VtptGfsuGZRJwdggXVjRrySUyYB21x2WF2mQIC5y8WOMWf87bspMiG6KrzOeY+JF2UlP1JNFV389LzuKOqv1G46P/BhiOWchnCG/BSNqcbX3zTS9GnGMwAX3CAvCxPm3KsPnG5GBC1Fopfuu5XXqetZa8U4u94xE6rxP6oM+7myYy5OUO0BHjGfoMA9oRqUXtpDrqm4VDTovPX+QgpnA9v745NcAnzxO0nmkgQEryizjJR0f6lfmkrDSH3zLDpQIgEJ0y8hvQOGbZ7TbU0QbE+dswg1gnWtQr7xFHm+SuMq2sKJUFSzIH+uRtsQ=='/><input type='submit' value='POST' style='display:none;'></form>`;
    console.log(form);
    this.apply = form;
    this.$nextTick(() => {
      //document.forms[0].submit();
      //document.forms['alipaysubmit'].submit();
    });    
  }
};
</script>
